/** @module others/renderOrderMenu */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Menu, message } from "@devowl-wp/react-folder-tree";
import { applyToAttachmentsBrowser } from "../hooks/sortable.js";
import { IS_DARKMODE, i18n, rmlOpts } from "../util/index.js";
const { Item, SubMenu, Divider } = Menu;
/**
 * An element rendering sortables for the popup menu.
 *
 * @returns React.Element[]
 */ const createSortables = (sortables, select, selectText)=>Object.keys(sortables).map((key)=>/*#__PURE__*/ _jsxs(Item, {
            children: [
                sortables[key],
                " ",
                select === key && /*#__PURE__*/ _jsxs("strong", {
                    children: [
                        "(",
                        selectText,
                        ")"
                    ]
                })
            ]
        }, key));
/**
 * Apply an order to a tree node object and afterwards reload the view.
 *
 * @this AppTree
 */ async function applyOrder(selected, key, automatically) {
    if (!rmlOpts.others.isPro && rmlOpts.others.showProHints) {
        this.setState({
            showProFeature: "order-content"
        });
    } else {
        const hide = message.loading(i18n("orderLoadingText", {
            name: selected.title
        }));
        const { attachmentsBrowser } = this;
        await selected.applyOrder(key, automatically);
        // Apply props to backbone model
        applyToAttachmentsBrowser(attachmentsBrowser, selected);
        this.handleReload();
        hide();
    }
}
/**
 * When clicking on a menu item in the order menu popup.
 *
 * @this AppTree
 */ async function handleClick(param) {
    let { key, keyPath } = param;
    const path = keyPath.reverse();
    const { selected } = this.props.store;
    const _applyOrder = applyOrder.bind(this);
    if (path[0] === "dnd") {
        this.handleOrderClick();
    } else if (path[0] === "applyOnce") {
        // Apply sorting once
        _applyOrder(selected, key);
    } else if (path[0] === "applyAutomatically") {
        _applyOrder(selected, key, true);
    } else if (key === "reset") {
        _applyOrder(selected, "original");
    } else if (key === "resetAutomatically") {
        _applyOrder(selected, "deactivate");
    } else if (key === "applyReindex") {
        _applyOrder(selected, "reindex");
    } else if (key === "applyResetLast") {
        _applyOrder(selected, "last");
    }
}
/**
 * Render the order menu.
 *
 * @type React.Element
 */ export default function() {
    const { store } = this.props;
    const { selected, sortables } = store;
    const isSortable = selected && selected.properties && selected.contentCustomOrder !== 2;
    if (!isSortable) {
        return /*#__PURE__*/ _jsx(Menu, {
            style: {
                visibility: "hidden"
            }
        });
    }
    return /*#__PURE__*/ _jsxs(Menu, {
        onClick: handleClick.bind(this),
        theme: IS_DARKMODE ? "dark" : "light",
        children: [
            !selected.orderAutomatically && /*#__PURE__*/ _jsx(Item, {
                children: i18n("orderByDnd")
            }, "dnd"),
            selected.contentCustomOrder !== 0 && /*#__PURE__*/ _jsx(Item, {
                children: i18n("resetOrder")
            }, "reset"),
            !selected.orderAutomatically && /*#__PURE__*/ _jsx(SubMenu, {
                title: i18n("applyOrderOnce"),
                disabled: selected.orderAutomatically,
                children: sortables && createSortables(sortables, selected.lastOrderBy, i18n("last"))
            }, "applyOnce"),
            selected.orderAutomatically && /*#__PURE__*/ _jsx(Item, {
                disabled: selected.contentCustomOrder === 0,
                children: i18n("deactivateOrderAutomatically")
            }, "resetAutomatically"),
            /*#__PURE__*/ _jsx(SubMenu, {
                title: i18n("applyOrderAutomatically"),
                children: sortables && createSortables(sortables, selected.orderAutomatically && selected.lastOrderBy, i18n("latest"))
            }, "applyAutomatically"),
            selected.contentCustomOrder === 1 && /*#__PURE__*/ _jsx(Divider, {}),
            selected.contentCustomOrder === 1 && /*#__PURE__*/ _jsx(Item, {
                children: i18n("reindexOrder")
            }, "applyReindex"),
            selected.contentCustomOrder === 1 && /*#__PURE__*/ _jsx(Item, {
                children: i18n("resetToLastOrder")
            }, "applyResetLast")
        ]
    });
}
